// extracted by mini-css-extract-plugin
module.exports = {"container1":"container1___BTbkc","nav":"nav___2E3ul","left":"left___3wR94","other":"other___20yT9","block":"block___74iXP","footer":"footer___2UWHw"};